/**
 * Whether a lineup player must stay hidden in the leaderboard modal.
 *
 * The API is the primary privacy boundary and nulls pre-kickoff opponent
 * players. This client-side check is defense in depth for opponent data. An
 * owner, however, must always be able to review their own returned players.
 */
export function shouldMaskContestLineupPlayer(
  isOwnLineup: boolean,
  playerExists: boolean,
  matchTime: string | null | undefined,
  nowMs: number = Date.now(),
): boolean {
  if (!playerExists) return true;
  if (isOwnLineup) return false;
  if (!matchTime) return true;

  const kickoffMs = Date.parse(matchTime);
  if (!Number.isFinite(kickoffMs)) return true;
  return kickoffMs > nowMs;
}
